var React = require('react');

function ArrowDownWithBody (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Arrow 1 (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M14.7071 19.3431L8.34314 25.7071C7.95262 26.0976 7.31946 26.0976 6.92893 25.7071L0.56497 19.3431C0.174445 18.9526 0.174445 18.3195 0.56497 17.9289C0.955495 17.5384 1.58866 17.5384 1.97918 17.9289L6.63604 22.5858L6.63604 1C6.63604 0.447715 7.08375 -3.4603e-07 7.63604 -3.21889e-07C8.18832 -2.97748e-07 8.63604 0.447715 8.63604 1L8.63604 22.5858L13.2929 17.9289C13.6834 17.5384 14.3166 17.5384 14.7071 17.9289C15.0976 18.3195 15.0976 18.9526 14.7071 19.3431Z","fill":"#001D3B"}));
}

ArrowDownWithBody.defaultProps = {"width":"15","height":"26","viewBox":"0 0 15 26","fill":"none"};

module.exports = ArrowDownWithBody;

ArrowDownWithBody.default = ArrowDownWithBody;
